import { Component, Input } from '@angular/core';
import { Badge } from './badge';
import { NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  imports: [NgIf, MatIcon],
})
export class BadgeComponent {
  badge: Badge;
  @Input() icon: string;
  @Input() text: string;
  @Input() eFormStatus: boolean = false;
  @Input() isComplete: boolean = false;
}
